import React from 'react';

const CustomerConfidence = () => {
  return (
    <section className="bg-gray-100 py-14 px-4 text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-800 animate-fade-in-up">
          Over <span className="text-green-600">10,000+</span> deals updated daily
        </h2>
        <p className="mt-2 text-gray-600 text-sm sm:text-base">
          Our marketplace syncs with AliExpress in real-time to keep you ahead of every trend.
        </p>
      </div>
    </section>
  );
};

export default CustomerConfidence;
